import { EvidenceKind, EvidenceStatus } from '@kainos/shared';
import type { Evidence } from '@kainos/validation';
import { DEMO_TENANT_ID } from './session.js';
import { daysAgo } from './time.js';

const audit = (at: string, by: string) => ({
  createdAt: at,
  createdBy: by,
  updatedAt: at,
  updatedBy: by,
});

/** Evidence tiles from the project Evidencias tab. */
export const DEMO_EVIDENCE: Array<Evidence & { activityTitle: string }> = [
  {
    ...audit(daysAgo(3), 'usr_carlos'),
    id: 'evd_1',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_plantanorte',
    activityId: 'act_2',
    activityTitle: 'Instalación tablero',
    kind: EvidenceKind.PHOTO,
    status: EvidenceStatus.READY,
    fileName: 'tablero_sectorB_01.jpg',
    mimeType: 'image/jpeg',
    sizeBytes: 1842000,
    s3Key: 'tenants/org_acme/projects/prj_plantanorte/evidence/evd_1/tablero_sectorB_01.jpg',
  },
  {
    ...audit(daysAgo(1), 'usr_camila'),
    id: 'evd_2',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_plantanorte',
    activityId: 'act_4',
    activityTitle: 'Pruebas de continuidad',
    kind: EvidenceKind.PHOTO,
    status: EvidenceStatus.READY,
    fileName: 'continuidad_test.jpg',
    mimeType: 'image/jpeg',
    sizeBytes: 1204000,
    s3Key: 'tenants/org_acme/projects/prj_plantanorte/evidence/evd_2/continuidad_test.jpg',
  },
  {
    ...audit(daysAgo(1), 'usr_felipe'),
    id: 'evd_3',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_plantanorte',
    activityId: 'act_3',
    activityTitle: 'Montaje piping',
    kind: EvidenceKind.PHOTO,
    status: EvidenceStatus.READY,
    fileName: 'piping_l03.jpg',
    mimeType: 'image/jpeg',
    sizeBytes: 2105000,
    s3Key: 'tenants/org_acme/projects/prj_plantanorte/evidence/evd_3/piping_l03.jpg',
  },
];
